<template>
  <div class="login">
    <login-header v-bind="headerInfo"></login-header>
    <!--is_master为1页面-->
    <!-- 当 is_master 为 1 的时候显示的用户登录界面 -->
    <div>
      <!-- 当 is_master 为 0 的时候显示的用户的界面 -->
      <div class="content clearfix" v-cloak>
        <div class="zc-tit">用户登录</div>
        <div class="dl-box" v-loading="loading">
          <form>
            <ul class="dl-list">
              <li class="clearfix login-input">
                <label>账号</label>
                <input type="text" class="input" placeholder="请输入手机号码" v-model="outerInfo.phone" />
              </li>
              <li class="clearfix yzm login-input">
                <label>密码</label>
                <input
                  type="password"
                  class="input"
                  placeholder="设置密码 "
                  v-model="outerInfo.pwd"
                  @keyup.enter="loginFn(outerInfo.phone,outerInfo.pwd,outerInfo.checked)"
                />
              </li>
            </ul>
            <div
              class="yellow-btn"
              @click="loginFn(outerInfo.phone,outerInfo.pwd,outerInfo.checked)"
            >登 录</div>
          </form>
        </div>
      </div>
    </div>

    <!--is_master为0页面-->
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
// 头部模块
import loginHeader from '../header'
// 底部模块
import loginFooter from '../footer'
// 滑动验证模块
import qs from 'qs'
// 引入生成二维码插件
import QrCode from 'qrcodejs2'
import Cookies from 'js-cookie'
import axios from 'axios'
axios.defaults.withCredentials = true // 允许携带cookie
export default {
  name: 'login',

  // 导入子组件
  components: {
    loginHeader, // 头部模块
    loginFooter // 底部模块
  },

  data() {
    return {
      loading: false,
      headerInfo: {
        type: '用户登录',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '',
      userInfo: {
        phone: '',
        pwd: '',
        checked: 'checked'
      },
      outerInfo: {
        phone: '',
        pwd: '',
        checked: 'checked'
      },
      msg: '',
      is_master: '', // 判断状态值，根据状态值，判断是否显示哪一个页面
      loginInfo: {},
      centerDialogVisible: false,
      hostUrl: '',
      is_from_auth: false, // 是否由授权页面跳回
      business_grant_token: '', // 外部页面跳转回来的token
      loginToken: '', // 登录token
      loginSeconds: '', // 登录过期时间
      pageSwitching: true, // 控制页面切换
      erWenResult: 1, // 用于接受扫码返回结果,渲染不同页面
      erWenMaUrl: '', // 生成二维码的链接
      timeId: null, // 时间定时器
      websocket: null, // websocket用于通信
      WebSocketUrl: '', // 建立websocket用于通信的url地址
      timeoutObj: ''// 发送ping的定时器
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.is_from_auth = from.name == 'storeAuth' // 判断是否是从店铺授权页面进入
    })
  },
  created() {
    // 如果从店铺授权页面跳过来的接受参数
    this.business_grant_token = this.$route.query.open_business_grant_token ? this.$route.query.open_business_grant_token : ''
    // 获取当前域名
    const hostName = window.location.hostname
    if (hostName !== 'www.zvcms.com') {
      const n = hostName.indexOf('.')
      if (n) {
        const host = hostName.substring(n + 1, hostName.length)
        if (host.length > 0) {
          this.hostUrl = host
        }
      }
    } else {
      this.hostUrl = 'zmcms.cn'
    }

    // 页面初始化时，如果帐号密码cookie存在则填充
    if (this.getCookie('user')) {
      this.outerInfo.phone = this.getCookie('user')
      // this.outerInfo.pwd= getCookie('pswd');
      this.outerInfo.checked = true
    }
    // ----------------------------------------------------------
    var timeout = JSON.parse(localStorage.getItem('timeout'))

    if (timeout) {
      // 处理异常，
      if (timeout.cod == 9001 || timeout.code == 9002) {
        // this.$message.error(timeout.message);
      }
    }

    // 如果是其他机构再请求接口
    if (this.hostUrl != 'zmcms.cn' && this.hostUrl != 'qimai.shop' && this.hostUrl != 'qmai.cn' && this.hostUrl != 'qmai.co') {
      var that = this
      // 授权登录接口
      QM.apinew({
        url: '/seller/organization/info',
        method: 'GET',
        success: function (xdata) {
          document.title = xdata.data.name // 结构名称
          that.loginInfo = xdata.data
          localStorage.setItem('title', xdata.data.name) //  ？
          localStorage.setItem('xdata', qs.stringify(xdata.data)) //  ？
          that.is_master = that.loginInfo.is_master // 开发商， 1 表示使我们企业云商， 0 不是
          that.headerInfo.logo = that.loginInfo.logo // 商家后台 / 登录页用的 logo
          that.desc = that.loginInfo.desc // 版权信息
        },
        error: function (xdata) {
          // console.log("")
          // alert("1")
        }
      })
    } else { // 企迈环境顶部和底部信息设置
      var info = {
        name: '企迈云商',
        logo: 'https://img-shop.qmimg.cn/s16/images/2019/06/18/d76b9262c466ba5d.png',
        desc: '<p><a href="https://www.qmai.cn" target="_blank">安徽智迈科技股份有限公司</a> 版权所有 Copyright 2009-2018 皖公网安备34019202000074号&nbsp; 增值电信业务经营许可证：皖B2-20170075</p>'
        // <p><img width="11px" src="https://img-shop.qmimg.cn/public/img/ico_safe.png"/>&nbsp;通过ISO27001:2013 信息安全认证通过ISO9001:2008质量管理体系认证</p>
      }
      this.headerInfo.logo = info.logo
      this.desc = info.desc
      document.title = info.name
      localStorage.setItem('xdata', qs.stringify(info))
      localStorage.setItem('title', info.name)
    };
    this.getLoginToken()

    console.log(this.$route)
    let { mobile, password } = this.$route.query
    if (mobile && password) {
      this.loginFn(mobile, password)
    }
  },

  methods: {
    // 记住密码复选框
    // checkOrNot(chk){
    //   if(!chk){
    //     this.delCookie('user');
    //   }
    // },

    // 设置cookie
    setCookie(name, value, day) {
      var date = new Date()
      date.setDate(date.getDate() + day)
      document.cookie = name + '=' + value + ';expires=' + date
    },

    // 获取cookie
    getCookie(name) {
      var reg = RegExp(name + '=([^;]+)')
      var arr = document.cookie.match(reg)
      if (arr) {
        return arr[1]
      } else {
        return ''
      }
    },

    // 删除cookie
    delCookie(name) {
      this.setCookie(name, null, -1)
    },

    // 点击登录功能
    loginFn(phone, pwd, chk) {
      var that = this

      that.loading = true
      axios.post('https://inapi.qmai.cn/gw/org-center/account/login', {
        username: phone,
        password: this.$base64.encode(this.$base64.encode(pwd)),
        version: 2
      }).then(() => {
        axios.get('https://inapi.qmai.cn/gw/org-center/not-group/list-account-group').then(groupRes => {
          let { data } = groupRes.data
          let groupId = data[0].id
          axios.get(`https://inapi.qmai.cn/gw/org-center/not-group/select-group?groupId=${groupId}`).then(() => {
            axios.get('https://inapi.qmai.cn/gw/org-center/not-power/list-role-org').then(orgRes => {
              let { data } = orgRes.data
              let org = data[0]
              axios.post('https://inapi.qmai.cn/gw/org-center/not-power/select-role-org', {
                type: org.type,
                typeId: org.typeId
              }).then(() => {
                window.location.href = `http://cy-plugin.${that.hostUrl}/#/windowOrders-li/orderList/takeoutList?isGw=1`
                that.loading = false
              })
            })
          })
        })
      })
      // QM.apinew({
      //   url: '/seller/account/login',
      //   method: 'POST',
      //   data: {
      //     mobile: phone,
      //     password: that.$base64.encode(pwd)
      //   },
      //   success: function (xdata) {
      //     // document.cookie='user='+phone+';'+'chk'+this.outerInfo.checked
      //     if (chk) {
      //       document.cookie = `user=` + phone
      //     } else {
      //       that.delCookie('user')
      //     }
      //     that.msg = xdata.message
      //     localStorage.setItem('mobile', phone)
      //     localStorage.setItem('mytoken', xdata.data.id)
      //     QM.apinew({
      //       url: '/seller/store/index',
      //       method: 'get',
      //       success: function (storeRes) {
      //         QM.apinew({
      //           url: '/seller/store/select',
      //           method: 'post',
      //           data: {
      //             store_id: storeRes.data.stores[0].id
      //           },
      //           success: function () {
      //             window.location.href = `//cy-plugin.${that.hostUrl}/#/windowOrders-li/orderList/takeoutList`
      //             that.loading = false
      //           },
      //           error: function (xdata) {
      //             that.$message.error(xdata.message)
      //           }
      //         })
      //       }
      //     })
      //   },
      //   error: function (xdata) {
      //     that.$message.error(xdata.message)
      //     that.loading = false
      //   }
      // })
    },

    // 点击切换到登陆页
    toggleSaoma () {
      if (this.erWenMaUrl) {
        this.pageSwitching = false
        this.$nextTick(() => {
          this.createCode(this.$refs.pay, this.erWenMaUrl)
        })
        this.connectWebsocket()
        this.updownTime()
      }
    },
    // 点击切换到扫码页
    toggleLogin () {
      this.pageSwitching = true
      this.websocket.close()
    },
    // 生成二维码图片的封装
    createCode (session, text) {
      let qrcode = new QrCode(session, {
        text: text,
        width: 166,
        height: 166,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QrCode.CorrectLevel.H
      })
    },
    // 获取登陆令牌和过期秒数
    getLoginToken (scallBack) {
      QM.apinew({
        url: '/seller/account/login-token',
        method: 'GET',
        success: res => {
          if (res.status) {
            this.loginToken = res.data.lg_token
            this.loginSeconds = res.data.seconds
            this.erWenMaUrl = res.data.url
            scallBack && scallBack()
          }
        },
        error: error => {
          this.$message.error(error)
        }
      })
    },
    // 建立websocket
    connectWebsocket () {
      if (this.hostUrl === 'zmcms.cn') {
        this.WebSocketUrl = 'wss://websocket.zmcms.cn/qrcode-login'
      } else if (this.hostUrl === 'qimai.shop') {
        this.WebSocketUrl = 'wss://websocket.qimai.shop/qrcode-login'
      } else if (this.hostUrl === 'qmai.co') {
        this.WebSocketUrl = 'wss://websocket.qmai.co/qrcode-login'
      } else if (this.hostUrl === 'qmai.cn') {
        this.WebSocketUrl = 'wss://websocket.qmai.cn/qrcode-login'
      }
      this.websocket = new WebSocket(this.WebSocketUrl)
      this.websocket.onopen = event => {
        let data = {
          'type': 'bind-uid',
          'data': { 'id': this.loginToken }
        }
        this.websocket.send(JSON.stringify(data))
      }

      this.websocket.onmessage = event => {
        let parseEvent = JSON.parse(event.data)
        if (parseEvent.type === 'scan_qrcode_success') { // 接收扫码成功消息
          this.erWenResult = 2
          if (this.erWenResult === 2) {
            this.listeningPage()
          }
        } else if (parseEvent.type === 'confirm_login') { // 接收确认登录消息
          if (parseEvent.data) {
            localStorage.setItem('mobile', parseEvent.data.mobile)
            localStorage.setItem('mytoken', parseEvent.data.id)
            Cookies.set(parseEvent.data.cookie.cookie_name, parseEvent.data.cookie.cookie_value, { expires: parseEvent.data.cookie.cookie_expire / 60 / 24, domain: `.${this.hostUrl}` })
            this.erWenResult = 1
            this.websocket.close()
            window.clearInterval(this.timeoutObj)
            window.onbeforeunload = () => {}
            this.$router.push({ path: '/index.html' })
          }
        } else if (parseEvent.type === 'cancel_login') { // 接口取消登录消息
          this.erWenResult = 3
          this.websocket.close()
        } else if (parseEvent.type === 'success') {
          this.sendHeartbeat()
        }
      }
    },
    // 登录被拒收重新返回登录
    goBack () {
      this.erWenResult = 1
      this.getLoginToken(() => {
        this.connectWebsocket()
        document.getElementsByClassName('qr-code-box')[0].innerHTML = ''
        this.$nextTick(() => {
          this.createCode(this.$refs.pay, this.erWenMaUrl)
        })
        this.updownTime()
      })
    },
    // 监听阻止页面刷新事件
    listeningPage () {
      if (this.erWenResult === 2) {
        window.onbeforeunload = function (e) {
          var dialogText = '请勿刷新页面'
          e.returnValue = dialogText
          return dialogText
        }
      }
    },
    // 二维码失效倒计时
    updownTime () {
      this.loginSeconds--
      window.clearInterval(this.timeId)
      if (this.loginSeconds === 0) {
        this.erWenResult = 4
        this.websocket.close()
        window.clearInterval(this.timeId)
      }
      this.timeId = window.setInterval(() => {
        this.updownTime()
      }, 1000)
    },
    // 二维码失效，点击登录
    addNewPage () {
      this.erWenResult = 1
      this.getLoginToken(() => {
        this.connectWebsocket()
        document.getElementsByClassName('qr-code-box')[0].innerHTML = ''
        this.$nextTick(() => {
          this.createCode(this.$refs.pay, this.erWenMaUrl)
        })
        this.updownTime()
      })
    },
    // 封装一个发送心跳定时器
    sendHeartbeat () {
      window.clearInterval(this.timeoutObj)
      this.timeoutObj = window.setInterval(() => {
        let nowTime = new Date().getTime()
        let data = {
          'type': 'ping',
          'data': `${nowTime}`
        }
        this.websocket.send(JSON.stringify(data))
        this.sendHeartbeat()
      }, 5000)
    },

    makeApiUrl(url) {
      var domain_str = location.hostname.split('.')
      var domain = domain_str[domain_str.length - 2] + '.' + domain_str[domain_str.length - 1]
      var protocol = location.protocol
      var api_prefix = 'inapi.'
      return protocol + '//' + api_prefix + domain + '/' + 'web' + url
      // return '/web' + url
    }
  }
}
</script>

<style scoped>
.yellow-btn {
  text-align: center;
  line-height: 50px;
  margin-top: 50px;
}
.yellow-btn:hover {
  background: #fde36d;
}
[v-cloak] {
  display: none;
}
.download-btn {
  cursor: pointer;
}
</style>
<style>
.el-icon-circle-check {
  font-size: 46px;
  color: #3fb838;
  margin-bottom: 28px;
}
.el-icon-warning {
  font-size: 46px;
  color: #f26365;
  margin-bottom: 28px;
}
.saoma-login {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.saoma-login .tit {
  color: #333333;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  margin-bottom: 64px;
}
.saoma-login .des {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 20px;
}
.saoma-login .note {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 15px;
}
.saoma-login .success {
  width: 68px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  background: rgba(26, 173, 25, 1);
  border-radius: 4px;
  color: #fff;
}
.saoma-login .qr-code-box {
  margin-left: 3px;
}
.saoma-login .title {
  margin-bottom: 35px;
}
.use-saoma {
  color: #666666;
}
.login-error {
  position: relative;
}
.saoma-img {
  width: 166px;
  height: 166px;
}
.refuse-tit {
  color: #333333;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  margin-bottom: 30px;
}
.defeated-bg {
  width: 166px;
  height: 166px;
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}
.defeated {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.login-input {
  height: 62px;
  overflow: hidden;
}
</style>